import React, { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { ICON_NAVIGATE_BACK } from 'assets/icons';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import StatusButton from 'containers/ProductList/components/StatusButton';
import { Product, ProductState } from 'types/api';
import ModifyButton from './ModifyButton';
import {
  formatDialogText,
  formatModifyText,
  renderDialogDescription,
  renderDialogTitle,
} from 'utils/formatting';
import ConfirmDialog from 'components/Modal/ConfirmDialog';
import { ModifyValue } from '../hooks/useProductDetaillHooks';
import CommonImage from 'components/common/CommonImage';
import MenuSettingButton from 'components/Button/MenuSettingButton';

const HeaderContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  position: sticky;
  top: 0;
  padding: ${props => (props.$isMobile ? '24px 20px' : '32px 20px')};

  width: 100%;
  background: #fff;
  z-index: 6;
`;

const BackwardButton = styled.button`
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  background-color: #f4f4f5;

  img {
    width: 16px;
    height: 16px;
  }
`;

interface ProductHeaderIProps {
  isMobile: boolean;
  isSelected: boolean;
  productInfo: Product;
  modifyValue: ModifyValue;
  handleSetProductStatus: (status: ProductState) => void;
  setIsOpenCloseProductDetail: Dispatch<SetStateAction<boolean>>;
  handleSetMenuType: (type: string) => void;
  setModifyValue: Dispatch<SetStateAction<ModifyValue>>;
}

const ProductHeader: React.FC<ProductHeaderIProps> = props => {
  const {
    isMobile,
    isSelected,
    productInfo,
    modifyValue,
    handleSetProductStatus,
    setIsOpenCloseProductDetail,
    handleSetMenuType,
    setModifyValue,
  } = props;

  const navigate = useNavigate();

  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);

  const handleNavigateBack = () => {
    if (modifyValue.isModify) {
      setIsOpenCloseProductDetail(true);

      return;
    }
    navigate(-1);
  };

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <HeaderContainer $isMobile={isMobile}>
          <Row justifyContent="space-between" style={{ width: '100%' }}>
            <Row justifyContent="center" gap="16px">
              <CommonImage
                src={ICON_NAVIGATE_BACK}
                onClick={handleNavigateBack}
              />

              <Text color="#1b1c1e" size="24px">
                상품 수정
              </Text>
            </Row>
            <Row justifyContent="space-between" gap="16px">
              <StatusButton
                status={productInfo.status}
                style={{ border: 'none' }}
              />
              <ModifyButton
                text={formatModifyText(productInfo.status)}
                onClick={() => setIsOpenDialog(true)}
                style={{ borderRadius: '12px' }}
              />
            </Row>
          </Row>
          <MenuSettingButton
            isMobile={isMobile}
            isSelected={isSelected}
            firstMenu="상세 페이지"
            secondMenu="옵션 • 일정"
            modifyValue={modifyValue}
            handleSetMenuType={handleSetMenuType}
            setModifyValue={setModifyValue}
          />
        </HeaderContainer>
      );
    }

    return (
      <HeaderContainer $isMobile={isMobile}>
        <Row
          justifyContent="flex-start"
          gap="24px"
          style={{
            width: '100%',
          }}
        >
          {/* <BackwardButton style={{ position: 'static' }}> */}
          <CommonImage src={ICON_NAVIGATE_BACK} onClick={handleNavigateBack} />
          {/* </BackwardButton> */}
          <Text color="#1b1c1e" size="24px">
            상품 수정
          </Text>
        </Row>
        <MenuSettingButton
          isMobile={isMobile}
          isSelected={isSelected}
          firstMenu="상세 페이지"
          secondMenu="옵션 • 일정"
          modifyValue={modifyValue}
          handleSetMenuType={handleSetMenuType}
          setModifyValue={setModifyValue}
        />
      </HeaderContainer>
    );
  };

  return (
    <React.Fragment>
      {renderContents()}

      {isOpenDialog && (
        <ConfirmDialog
          title={renderDialogTitle(productInfo.status)}
          description={renderDialogDescription(productInfo.status)}
          onClose={() => {
            setIsOpenDialog(false);
          }}
          onCloseText="아니요"
          onAcceptText={formatDialogText(productInfo.status)}
          onAccept={() => {
            handleSetProductStatus(productInfo.status);

            setIsOpenDialog(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ProductHeader;
